import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function PaymentCancelPage() {
  return (
    <div className="max-w-lg mx-auto py-16 px-4">
      <Card>
        <CardContent className="p-8 text-center">
          <XCircle className="h-12 w-12 mx-auto text-muted-foreground mb-4" />
          <p className="font-display uppercase text-2xl mb-2">Paiement annulé</p>
          <p className="text-sm text-muted-foreground mb-6">Aucun montant n'a été débité. Vous pouvez retenter à tout moment.</p>
          <Button asChild><Link to="/boutique-web">Retour à la boutique</Link></Button>
        </CardContent>
      </Card>
    </div>
  );
}
